import { render, staticRenderFns } from "./ui-input-handler.vue?vue&type=template&id=53836080&"
import script from "./ui-input-handler.vue?vue&type=script&lang=js&"
export * from "./ui-input-handler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports